import { __awaiter } from "tslib";
import { useMsal } from '@azure/msal-react';
import { merge } from '@fluentui/react';
import { v4 } from 'uuid';
import { getDefaultHeaders } from '../../../msrcHttpDefault/getDefaultHeaders';
import { isOurApi } from '../isOurApi';
import { useAcquireToken } from '../../../authContext';
import { InteractionStatus } from '@azure/msal-browser';
/**
 * Axios interceptor function that adds the Authorization header to all
 * requests to our own API's.
 */
export const useAuthAxiosInterceptorFunction = () => {
    const { instance, inProgress } = useMsal();
    const account = instance.getActiveAccount();
    const acquireTokenSilent = useAcquireToken();
    return (config) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // WARNING! THIS INTERCEPTOR HAS ITS OWN SCOPE AND CONTEXT,
        // AND IS CALLED BASICALLY ON ANOTHER PLANET.
        // DON'T ATTEMPT TO CALL THINGS LIKE "instance.getActiveAccount()" here!
        //Only do this for the API calls against our own API's
        if (isOurApi(config)) {
            const token = (inProgress !== InteractionStatus.Startup &&
                (account === null || account === void 0 ? void 0 : account.idTokenClaims) &&
                ((_a = (yield acquireTokenSilent())) === null || _a === void 0 ? void 0 : _a.accessToken)) ||
                undefined;
            const defaultHeaders = getDefaultHeaders(token);
            /** Unique ID added to request for easier debugging */
            const requestId = v4();
            // Append existing headers to 'headers' object to ensure that any extra
            // headers are not wiped out.
            config.headers = merge({}, defaultHeaders, {
                'Request-Id': requestId,
                'X-Request-Id': requestId,
            }, config.headers);
        }
        return config;
    });
};
